module.exports = __webpack_public_path__ + "img/icon-plain-feedback.fdab3b61.svg";